import { GET_PROFILE_PRODUCT_SHARES, GET_PRODUCTS } from "../actions/types";
const initialState = {
    table: null,
    list: null,
    categories: null
};

function productReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_PROFILE_PRODUCT_SHARES:
            return {
                ...state,
                table: payload,
            }
        case GET_PRODUCTS:
            return {
                ...state,
                list: payload
            };
        default:
            return state;
    }
}

export default productReducer;
